import {UserStoreActions} from "./UserStore";
import {EventStoreActions} from "./EventStore";
import {OrganizationStoreActions} from "./OrganizationStore";
import {PulseStoreActions} from "./PulseStore";

export function flushStores() {
    EventStoreActions.flushStore();
    OrganizationStoreActions.flushStore();
    PulseStoreActions.flushStore();
    UserStoreActions.flushStore();
}
